// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"c-link\" ng-bind=\"row.entity.Name\" ng-click=\"row.entity.clickHandler()\"></div>\n</div>\n";
// Exports
module.exports = code;